import httpService from "@/utils/services/http_service";

export default{
    /**
   * @author: liuxiangmin
   * date: 2020-03-09
   *  应对库
   */
  
  // 应对库记录列表
  async responseList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_list',
      data
    )
  },
  
  // 应对库分类创建
  async classifyCreate(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_cate_create',
      data
    )
  },
  
  // 应对库分类列表
  async classifyList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_cate_list',
      data
    )
  },
  
  // 应对库记录创建
  async recordedCreate(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_create',
      data
    )
  },
  
  // 应对库记录删除
  async recordedDelete(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_delete',
      data
    )
  },
  
  // 应对库记录修改
  async recordedEdit(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_edit',
      data
    )
  },
  
  // 应对库记录信息
  async recordedInformation(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_list',
      data
    )
  },
  
  // 	应对库记录列表
  async recordList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_list',
      data
    )
  },


  // 1.6 by -lafitewu
  async expertList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_expert_list',
      data
    )
  },

  async addExpert(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_expert_create',
      data
    )
  },

  async editExpert(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_expert_edit',
      data
    )
  },

  async mediaList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_media_list',
      data
    )
  },

  async addMedia(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_media_create',
      data
    )
  },

  async editMedia(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_media_edit',
      data
    )
  },
}